import styles from "./AssessmentTypes.module.scss";
import { classNames } from "@/shared/lib/classNames/classNames";
import { Link } from "react-router-dom";

export const AssessmentTypes = () => {
    return (
        <div className={styles.AssessmentTypes}>
            <div className={styles.title}>
                <span>Types</span> of phychophysical constitution assessment
            </div>
            <div className={styles.content}>
                <div className={styles.block}>
                    <div className={styles.position}>01</div>
                    <div className={styles.blockTitle}>
                        PC ASSESSMENT WITHOUT DIAGNOSTICS
                    </div>
                    <button className={styles.blockButton}>PAY $1200</button>
                </div>
                <div className={classNames(styles.block, {}, [styles.second])}>
                    <div className={styles.position}>02</div>
                    <div className={styles.blockTitle}>
                        PC ASSESSMENT WITH DIAGNOSTICS
                    </div>
                    <button className={styles.blockButton}>PAY $1430</button>
                </div>
                <div className={styles.block}>
                    <div className={styles.position}>03</div>
                    <div className={styles.blockTitle}>REPEAT DIAGNOSTICS</div>
                    <button className={styles.blockButton}>PAY $170</button>
                </div>
                <div className={classNames(styles.block, {}, [styles.second])}>
                    <div className={styles.position}>04</div>
                    <div className={styles.blockTitle}>
                        DIAGNOSTICS WITHOUT DR. TORSUNOV
                    </div>
                    <button className={styles.blockButton}>PAY $60</button>
                </div>
            </div>
            <div className={styles.filOut}>
                <div className={styles.filOutTitle}>
                    Please <span>answer the questions </span>
                    in the form by clicking
                    <br /> the button below{" "}
                </div>
                <div className={styles.buttonBlock}>
                    <div className={styles.buttonWrapper}>
                        <button className={styles.buttonSign}>
                            <Link
                                to={
                                    "https://docs.google.com/forms/d/1ZbsYYP7bdwaHaNh0MAE1C7pT31L2vfo67V9-8p1qDwU/viewform?edit_requested=true"
                                }
                            >
                                BOOK MY CONSULTATION
                            </Link>
                        </button>
                    </div>
                    <div className={styles.link}>
                        <Link
                            to={"https://forms.gle/5toEbdGAqvgdQ3no8"}
                            target="_blank"
                        >
                            ASK A QUESTION
                        </Link>
                    </div>
                </div>
                <div className={styles.filOutText}>
                    After filling out the form, our manager will contact you
                    within 48 hours.
                </div>
            </div>
        </div>
    );
};
